import { motion } from "framer-motion";
import { forwardRef } from "react";
import { useTheme } from "styled-components";
import { SPINNER_SVG_PATHS, SPINNER_SVG_PATH_ANIMATION_DELAY } from "./Spinner.constants.js";
import { getFillMap, sizeMap } from "./Spinner.style.js";
import { DefaultSpinnerProps, SpinnerProps } from "./Spinner.types.js";

const defaultProps: DefaultSpinnerProps = {
    color: "currentColor",
    size: "medium",
};

export const Spinner = forwardRef<SVGSVGElement, SpinnerProps>((props, ref): JSX.Element => {
    const { color, size, ...attributes } = { ...defaultProps, ...props };

    const theme = useTheme();

    const computedSize = sizeMap[size];
    const fill = getFillMap({ theme })[color];

    return (
        <svg
            ref={ref}
            {...attributes}
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: computedSize, height: computedSize }}
            viewBox="0 0 40 40"
            fill="none"
        >
            <g clipPath="url(#clip0_1033_13456)">
                {SPINNER_SVG_PATHS.map((path, idx) => (
                    <motion.path
                        key={idx}
                        animate={{
                            opacity: [1, 0, 1],
                        }}
                        transition={{
                            repeat: Infinity,
                            duration: SPINNER_SVG_PATH_ANIMATION_DELAY * SPINNER_SVG_PATHS.length,
                            delay: idx * SPINNER_SVG_PATH_ANIMATION_DELAY,
                        }}
                        d={path}
                        fill={fill}
                    />
                ))}
            </g>
            <defs>
                <clipPath id="clip0_1033_13456">
                    <rect width="40" height="40" fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
});
